

import { useState, useEffect } from 'react';  
import { storageMng } from '../helper/StorageMng';
import { LectureSummaryModel } from '../generated/api';

export const useShoppingManager = () => {
  const [cartItems, setCartItems] = useState<LectureSummaryModel[]>(() => {
    const sessionData = storageMng.getItem("cartItems");
    return sessionData ? JSON.parse(sessionData) : [];
  });

  useEffect(() => {
    storageMng.setItem("cartItems", JSON.stringify(cartItems));
  }, [cartItems]);

  const addToCart = (item: LectureSummaryModel) => {
    setCartItems(prev => [...prev, item]);
  };

  const removeFromCart = (lectureToken?: string) => {
    setCartItems(prev => prev.filter(lecture => lecture.token !== lectureToken));
  };

  const clearCart = () => {
    setCartItems([]);
  };

  const isItemInCart = (lectureToken?: string): boolean => {
    return cartItems.some(lecture => lecture.token === lectureToken);
  };

   
  return { cartItems, addToCart, removeFromCart ,clearCart , isItemInCart};
};
